export const contentVariants = {
  enter: dir => ({
    x: dir * 30 + '%',
    opacity: 0,
    transition: {
      x: {
        type: 'tween',
        duration: 0.3,
        ease: 'easeIn'
      },
      opacity: {
        duration: 0.25,
        ease: 'easeIn'
      }
    }
  }),
  center: {
    x: 0,
    opacity: 1
  },
  exit: dir => ({
    x: dir * -30 + '%',
    opacity: 0,
    transition: {
      x: {
        type: 'tween',
        duration: 0.3,
        ease: 'easeOut'
      },
      opacity: {
        duration: 0.25,
        ease: 'easeOut'
      }
    }
  })
};
export const contentTransition = {
  x: {
    type: 'tween',
    duration: 0.3,
    ease: 'easeInOut'
  },
  opacity: {
    duration: 0.25
  }
};